// extracted by mini-css-extract-plugin
export var deleteIcon = "_qa-5";
export var deleteOption = "_qa-3";
export var divider = "_qa-2";
export var downloadIcon = "_qa-4";
export var drawer = "_qa-0";
export var drawerFooter = "_qa-6";
export var drawerOpen = "_qa-1";
export var highlighted = "_qa-7";
export var lighterHighlight = "_qa-8";